import Phaser from "phaser";

export class FuelBar {
    /** 
     * * FuelBar constructor takes @param {Object} bar - object from phaser graphics - @param {number} x - x axis of bar - @param {number} y -y axis of bar - @param {number} max - repersent max fuel for this spaceship - @param {number }value - repersent current value of fuel - @param {number} percentage  -is hyperparameter
     *   decrease function : @param {number} amount - ammount of fuelbar that spaceship used it -
     *   draw function : calculate new value of fuel and update fuelbar on scene 
     *   loader function : load assets of fuel bar  @param {Object} scene -this scene that fuelbar belongs to - @param {String} key  - key of fuelbar - @param {String} value -path of image of fuelbar -
     *  */
    percentage = 1.8;
    constructor(scene, x, y, max, player) {
        this.bar = new Phaser.GameObjects.Graphics(scene);
        this.x = x;
        this.y = y;
        this.max = max;
        this.value = player.getfuel();
        this.scene = scene;
        this.scene.add.image(this.x + 107, this.y + 7, "health_bar_bg");
        this.draw();
        scene.add.existing(this.bar);
    }
    decrease(amount) {
        this.value = amount;
        if (this.value < 0) {
            this.value = 0;
        }
        this.draw();
        return this.value === 0;
    }
    draw() {
        this.bar.clear();
        this.realFuel = (this.value * 100) / this.max;
        if (this.realFuel < 30) {
            this.bar.fillStyle(0xff0000);
        } else {
            this.bar.fillStyle(0xf0cc1b);
        }
        this.distance = Math.floor(this.percentage * this.realFuel);
        this.bar.fillRect(this.x + 2, this.y + 2, this.distance, 12);
    }
    static loader(scene, key, value) {
        scene.load.image(key, value);
    }
}